import { notification } from 'antd'
import apiClient from '../index'

export const getAttendancePercentage = async (params) => {
  const { userId } = params
  try {
    return await apiClient.get('/dashboard/attendance-percentage', {
      params: {
        userId,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const getPendingPayroll = async (params) => {
  const { userId } = params
  try {
    return await apiClient.get('/dashboard/pending-payroll', {
      params: {
        userId,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const getPendingException = async (params) => {
  const { userId } = params
  try {
    return await apiClient.get('/dashboard/pending-exception', {
      params: {
        userId,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const getPendingExpense = () => apiClient.get('/dashboard/pending-expense')
export const getPendingReimbursement = async (params) => {
  const { userId } = params
  try {
    return await apiClient.get('/dashboard/pending-reimbursement', {
      params: {
        userId,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const getPendingOnboarding = () => apiClient.get('/dashboard/pending-onboarding')
export const getTopPerformerList = () => apiClient.get('/dashboard/top-performer-list')
export const getLeaveTaken = async (params) => {
  const { userId } = params
  try {
    return await apiClient.get('/dashboard/leave-taken', {
      params: {
        userId,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}

export const getEmpPunchLogs = async () => {
  try {
    const response = await apiClient.get('/dashboard/biometric/punchlogs')
    return response?.data
  } catch (error) {
    notification.error({
      message: error?.response?.data?.message || error?.message || 'Failed to fetch punch logs',
    })
    return null
  }
}

// export const getEmpCalendarPunches = async () => {
//   try {
//     const response = await apiClient.get('/dashboard/biometric/cal/punches')
//     return response?.data
//   } catch (error) {
//     notification.error({
//       message: error?.response?.data?.message || error?.message || 'Failed to fetch punch logs',
//     })
//     return null
//   }
// }
